import { createTheme, makeStyles, ThemeProvider, useTheme } from '@material-ui/core/styles';
import GetAppIcon from '@mui/icons-material/GetApp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchIcon from "@mui/icons-material/Search";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Button } from '@mui/material';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import * as React from 'react';
import { useSelector } from 'react-redux';
import DateRangePickerOmni from '../../../../../allGlobalComponents/DateRangePickerOmni';
import FormFieldOmni from '../../../../../allGlobalComponents/FormFieldOmni';
import TableOmniNew from '../../../../../allGlobalComponents/TableOmniNew';
import TicketDetailModal from './TicketDetailModal';
import ButtonOmni from '../../../../../allGlobalComponents/ButtonOmni';
import SnackbarOmni from 'allGlobalComponents/SnackbarOmni';
import { exportToExcel, formatDate } from 'app/utility/ExportToExcelUtility';
import { useApi, useSnackbar, usePagination } from 'app/hooks';

const SearchStyle = createTheme({
    overrides: {
        MuiInput: {
            root: {
                paddingTop: 0,
                fontSize: '12px',
                paddingBottom: 0,
                margin: 0,
                border: 0,
                borderRadius: 0,
                height: '30px'
            }
        }
    }
});

const useStyles = makeStyles(theme => ({
    '@global': {
        '.css-63800x': {
            paddingBottom: '0px !important',
            paddingLeft: '20px !important',
            paddingRight: '20px !important',
            width: '100% !important',
        },
    },
    btn: {
        width: 180,
        color: `${theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300]} !important`,
        borderColor: `${theme.palette.secondary.main} !important`,
        '&:hover': {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            color: 'white !important',
            borderColor: `${theme.palette.secondary.main} !important`,
        },
        display: "flex !important",
        justifyContent: "space-between !important",
        textTransform: "none !important",
        fontSize: "120% !important",
    },
    cards: {
        width: "30em",
        minWidth: `10em !important`,
        paddingTop: "1% !important",
        paddingLeft: "0.5% !important",
        margin: "0.5em 2em 0.5em 0em  !important",
        backgroundColor: `${theme.palette.type === 'light' ? "white" : theme.palette.grey[800]} !important`,
        color: theme.palette.type === 'light' ? "black !important" : "white !important",
        borderRadius: "5% !important"
    },
    cardssecondarytxt: {
        color: `${theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300]} !important`
    },
    FormFieldOmni: {
        width: "500px",
        borderRadius: "5px",
        padding: "5px 12px",
        display: "flex",
        alignItems: "center",
        "& input": {
            padding: "6px 12px",
            border: "none",
            outline: "none",
        },
        "& ::placeholder": {
            paddingLeft: "5px",
        }
    },
    menu: {
        backgroundColor: `${theme.palette.type === 'light' ? '#f6f7f9' : '#1e1d1e'} !important`,
        color: `${theme.palette.type === 'light' ? '#1e1d1e' : '#f6f7f9'} !important`,
        marginTop: "-8px !important",
        marginBottom: "-8px !important",
        '& :hover': {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            color: `white !important`
        }
    },
    datePickerParent: {
        "& .DateRangePickerInput_arrow": {
            color: `${theme.palette.type === 'light' ? 'black' : 'white'} !important`,
        },
        "&  .DateInput_input__small_2": {
            color: `${theme.palette.secondary.value} !important`,
        },
        "&  .DateInput_input::placeholder": {
            color: `${theme.palette.type === 'light' ? 'black' : 'white'} !important`,
        },
        '& > *': {
            padding: "2% 0% 3% 0%",
            color: `${theme.palette.type === 'light' ? 'black' : 'white'} !important`,
        },
    }
}));

export default function ComplainTicketsReport() {
    const classes = useStyles();
    const theme = useTheme();
    const mainTheme = useSelector(({ fuse }) => fuse.settings.mainTheme);

    // Custom hooks
    const { snackbar, showError, showWarning } = useSnackbar();
    const { isLoading, request } = useApi();
    const { request: requestSearch } = useApi();
    const { request: requestExport } = useApi();
    const { currentParams, setCurrentParams, totalItems, setTotalItems } = usePagination(10);

    // State for the dropdown menus:
    const [anchorEl, setAnchorEl] = React.useState(null);

    // API data and filters:
    const [apiData, setApiData] = React.useState([]);
    const [averageResolutionTime, setAverageResolutionTime] = React.useState("");
    const [selectedPlatform, setSelectedPlatform] = React.useState("");
    const [selectedAgent, setSelectedAgent] = React.useState("");
    const [selectedAgentID, setSelectedAgentID] = React.useState("");
    const [selectedTicketStatus, setSelectedTicketStatus] = React.useState("");
    const [selectedStartDate, setSelectedStartDate] = React.useState("");
    const [selectedEndDate, setSelectedEndDate] = React.useState("");
    const [ticketDetails, setTicketDetails] = React.useState('');
    const [searchText, setSearchText] = React.useState('');
    const [searchData, setSearchData] = React.useState([]);
    const [checkSearch, setCheckSearch] = React.useState(false);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [rawStartDate, setRawStartDate] = React.useState(null);
    const [rawEndDate, setRawEndDate] = React.useState(null);
    const [isExporting, setIsExporting] = React.useState(false);

    function dateWithStartingHour(newDate) {
        let start = newDate
            ? moment(newDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")
            : moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
        setSelectedStartDate(start);
        return start;
    }
    function dateWithEndingHour(newDate) {
        let end = newDate
            ? moment(newDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")
            : moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        setSelectedEndDate(end);
        return end;
    }

    const clearFilters = () => {
        setSelectedPlatform("");
        setSelectedAgent("");
        setSelectedAgentID("");
        setSelectedTicketStatus("");
        setSelectedStartDate("");
        setSelectedEndDate("");
        setRawStartDate(null);
        setRawEndDate(null);
        callApi();
    };

    // Build export columns dynamically based on max journey steps
    const buildExportColumns = (tickets) => {
        let maxJourneySteps = 0;
        tickets.forEach(ticket => {
            if (ticket.customer_journey) {
                const steps = ticket.customer_journey.split('\n').filter(s => s.trim());
                if (steps.length > maxJourneySteps) {
                    maxJourneySteps = steps.length;
                }
            }
        });

        const columns = [
            { header: 'S.No', key: '_index' },
            { header: 'Name', key: 'name' },
            { header: 'Channel', key: 'channel_type' },
            { header: 'Ticket Number', key: 'ticket_number' },
            { header: 'Status', key: 'status' },
            { header: "Number / Id's", key: 'number' },
            { header: 'Starting Date', key: 'dt', transform: (val) => formatDate(val) },
            { header: 'Ending Date', key: 'last_closed', transform: (val) => formatDate(val) },
            { header: 'Last Message', key: 'customer_message' },
        ];

        for (let i = 1; i <= maxJourneySteps; i++) {
            columns.push({
                header: `Journey Step ${i}`,
                key: `journey_step_${i}`,
                transform: (val, row) => {
                    if (!row.customer_journey) return '-';
                    const steps = row.customer_journey.split('\n').filter(s => s.trim());
                    return steps[i - 1] || '-';
                }
            });
        }

        return columns;
    };

    const downloadData = () => {
        // Fetch ALL tickets (not just paginated) using the same filters
        const exportParams = {
            page: 0,
            limit: totalItems || 999999,
            channel_type: selectedPlatform ? selectedPlatform : null,
            start_date: selectedStartDate ? selectedStartDate : null,
            end_date: selectedEndDate ? selectedEndDate : null,
            agent: selectedAgentID ? selectedAgentID : null,
            status: selectedTicketStatus ? selectedTicketStatus : null
        };

        setIsExporting(true);

        requestExport({
            module: 'complain',
            method: 'fetch_report',
            payload: exportParams,
            onSuccess: (response) => {
                const allTickets = response.data.data?.complaintMetadata?.tickets || [];

                if (allTickets.length === 0) {
                    showWarning('No data available for export');
                    setIsExporting(false);
                    return;
                }

                const columns = buildExportColumns(allTickets);

                exportToExcel({
                    fileNamePrefix: 'tickets_report',
                    dateRange: {
                        startDate: selectedStartDate,
                        endDate: selectedEndDate
                    },
                    sheets: [{
                        name: 'Tickets Report',
                        data: allTickets,
                        columns: columns
                    }]
                });

                setIsExporting(false);
            },
            onError: (message) => {
                showError(message || 'Error exporting tickets');
                setIsExporting(false);
            }
        });
    };

    const handleDateChange = ({ startDate, endDate }) => {
        setRawStartDate(startDate);
        setRawEndDate(endDate);
        if (startDate && endDate) {
            dateWithStartingHour(startDate);
            dateWithEndingHour(endDate);
        } else {
            // Picker was cleared — clear the applied dates too
            setSelectedStartDate("");
            setSelectedEndDate("");
        }
    };

    // Handle opening/closing the menu for the 3 dropdown buttons
    const handleClick = (index, event) => {
        setAnchorEl({ [index]: event.currentTarget });
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Each dropdown click sets the corresponding filter and closes the menu
    const selectedPlatformOnClick = (val) => {
        setSelectedPlatform(val.target.innerText);
        handleClose();
    };
    const selectedAgentOnClick = (val) => {
        setSelectedAgentID(val.id);
        setSelectedAgent(val.username);
        handleClose();
    };
    const selectedTicketStatusOnClick = (val) => {
        setSelectedTicketStatus(val.target.innerText);
        handleClose();
    };

    // Call the API
    const callApi = (
        platform,
        agentSelected,
        ticketStatus,
        startDate,
        endDate,
        pageParam = 0,
        limitParam = 10
    ) => {
        const params = {
            page: pageParam,
            limit: limitParam,
            channel_type: platform ? platform : null,
            start_date: startDate ? startDate : null,
            end_date: endDate ? endDate : null,
            agent: selectedAgentID ? selectedAgentID : null,
            status: ticketStatus ? ticketStatus : null
        };

        request({
            module: 'complain',
            method: 'fetch_report',
            payload: params,
            onSuccess: (_response) => {
                const meta = _response.data.data?.complaintMetadata;
                setApiData(meta);
                setTotalItems(meta?.total_tickets || 0);

                let seconds = meta?.avg_resolution_time?.difference;
                if (seconds != null) {
                    let days = Math.floor(seconds / (3600 * 24));
                    seconds -= days * 3600 * 24;
                    let hrs = Math.floor(seconds / 3600);
                    seconds -= hrs * 3600;
                    let mnts = Math.floor(seconds / 60);
                    seconds -= mnts * 60;
                    setAverageResolutionTime(
                        days + " days, " + hrs + " hrs, " + mnts + " min, " + seconds.toFixed(0) + " s"
                    );
                }
            },
            onError: (message) => showError(message || 'Error fetching tickets report')
        });
    };

    React.useEffect(() => {
        callApi();
    }, []);

    const searchTicket = () => {
        requestSearch({
            module: 'complain',
            method: 'search_ticket',
            payload: {
                ticket_number: searchText,
                channel_type: "whatsapp",
                ticket_type: 'active'
            },
            onSuccess: (response) => {
                setTicketDetails(response.data.data.list[0]);
            },
            onError: (message) => showError(message || 'Error searching ticket')
        });
    };

    const clearSearch = () => {
        setCheckSearch(false);
        setSearchData([]);
        setSearchText('');
    };

    const openTicket = (ticket) => {
        requestSearch({
            module: 'complain',
            method: 'search_ticket',
            payload: {
                ticket_number: ticket.ticket_number,
                channel_type: ticket.channel_type,
                ticket_type: 'active'
            },
            onSuccess: (response) => {
                setTicketDetails(response.data.data.list[0]);
            },
            onError: (message) => showError(message || 'Error opening ticket')
        });
    };

    const headCells = [
        { id: 'name', numeric: false, disablePadding: false, label: 'Name', tooltip: true },
        { id: 'channel_type', numeric: false, disablePadding: false, label: 'Channel' },
        { id: 'ticket_number', numeric: false, disablePadding: false, label: 'Ticket Number', tooltip: true },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'Status',
            pill: true,
            pillConfig: {
                mapping: {
                    'Pending': { label: 'Pending', color: '#92400E', bgColor: '#FEF3C7' },
                    'Resolved': { label: 'Resolved', color: '#065F46', bgColor: '#D1FAE5' },
                    'In Progress': { label: 'In Progress', color: '#1E40AF', bgColor: '#DBEAFE' },
                    'Closed': { label: 'Closed', color: '#6B7280', bgColor: '#F3F4F6' }
                }
            }
        },
        { id: 'number', numeric: false, disablePadding: false, label: "Number / Id's", tooltip: true },
        { id: 'dt', numeric: false, disablePadding: false, label: 'Starting Date', dt: true },
        { id: 'last_closed', numeric: false, disablePadding: false, label: 'Ending Date', dt: true },
        { id: 'customer_message', numeric: false, disablePadding: false, label: 'Last Message', msg: true, truncateLength: 25 },
        {
            id: 'openTicket',
            numeric: false,
            disablePadding: false,
            label: 'Open Ticket',
            customRow: (row) => (
                <Button onClick={() => openTicket(row)}>
                    <OpenInNewIcon />
                </Button>
            )
        },
    ];

    return (
        <>
            <Box sx={{
                margin: "1%",
                display: 'flex',
                alignItems: "center",
                padding: "20px",
                paddingLeft: "15px",
                fontWeight: "bold",
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.light,
                borderRadius: "15px"
            }}>
                <Typography sx={{ marginRight: "5%", display: { xs: 'none', sm: 'block' } }} variant="h4">
                    Complain Tickets Report
                </Typography>

                <FormFieldOmni
                    placeholder="Search"
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                    className={classes.FormFieldOmni}
                    InputProps={{
                        startAdornment: (
                            <SearchIcon />
                        ),
                    }}
                />
                <ButtonOmni
                    id="content-upload-button"
                    style={{
                        marginLeft: '8px'
                    }}
                    size="small"
                    onClick={searchTicket}
                    label="Search"
                >
                </ButtonOmni>
                <ButtonOmni
                    id="content-upload-button"
                    style={{
                        marginLeft: '8px'
                    }}
                    label="Clear"
                    size="small"
                    onClick={clearSearch}
                >
                </ButtonOmni>

                <TicketDetailModal ticketDetails={ticketDetails} />
            </Box>

            {/* Main Content */}
            <Box sx={{ padding: "4%", width: "100%" }}>
                <Typography sx={{ paddingBottom: "3%" }} variant="h5" color={theme.palette.secondary.value} gutterBottom>
                    Check the current status of your team's workload and availability
                </Typography>

                <Box display={"flex"} alignItems="center" sx={{ marginBottom: "5%", flexWrap: "wrap" }}>
                    <Box sx={{ paddingX: "1%", width: "fit-content", marginTop: "2%" }} className={classes.datePickerParent}>
                        <DateRangePickerOmni
                            startDate={rawStartDate}
                            endDate={rawEndDate}
                            onDateChange={handleDateChange}
                            defaultNull={false}
                        />
                    </Box>

                    <Box sx={{ paddingX: "1%" }}>
                        <Typography variant="h5" paddingBottom={1} component="div">
                            Platform
                        </Typography>
                        <FormFieldOmni
                            size="small"
                            label="Select Platform"
                            variant="outlined"
                            value={selectedPlatform}
                            onChange={(e) => setSelectedPlatform(e.target.value)}
                            type="select"
                            options={
                                apiData?.channel_type?.map(s => ({
                                    label: s.charAt(0).toUpperCase() + s.slice(1),
                                    value: s
                                }))
                            }
                            style={{ width: "200px" }}
                        />
                    </Box>

                    {/* Agent Selector */}
                    <Box sx={{ paddingX: "1%" }}>
                        <Typography variant="h5" paddingBottom={1} component="div">
                            Agent
                        </Typography>
                        <FormFieldOmni
                            size="small"
                            label="Select Agent"
                            variant="outlined"
                            value={selectedAgent}
                            onChange={(e) => {
                                const selected = apiData?.agents?.find(agent => agent.username === e.target.value);
                                if (selected) {
                                    setSelectedAgentID(selected.id);
                                    setSelectedAgent(selected.username);
                                }
                            }}
                            type="select"
                            options={
                                apiData?.agents?.map(s => ({
                                    label: s.username,
                                    value: s.username
                                }))
                            }
                            style={{ width: "200px" }}
                        />
                    </Box>

                    {/* Ticket Status Selector */}
                    <Box sx={{ paddingX: "1%" }}>
                        <Typography variant="h5" paddingBottom={1} component="div">
                            Ticket Status
                        </Typography>
                        <FormFieldOmni
                            size="small"
                            label="Select Ticket Status"
                            variant="outlined"
                            value={selectedTicketStatus}
                            onChange={(e) => setSelectedTicketStatus(e.target.value)}
                            type="select"
                            options={
                                apiData?.statuses?.map(s => ({
                                    label: s.charAt(0).toUpperCase() + s.slice(1),
                                    value: s
                                }))
                            }
                            style={{ width: "200px" }}
                        />
                    </Box>

                    {/* Apply / Clear Filter Buttons */}
                    <Box sx={{ marginLeft: "5px", marginTop: "2.5em" }}>
                        <ButtonOmni
                            onClick={() => callApi(
                                selectedPlatform,
                                selectedAgent,
                                selectedTicketStatus,
                                selectedStartDate,
                                selectedEndDate
                            )}
                            label="Apply Filters"
                        />
                    </Box>
                    <Box sx={{ marginLeft: "5px", marginTop: "2.5em" }}>
                        <ButtonOmni
                            onClick={clearFilters}
                            label="Clear Filters"
                        />
                    </Box>
                </Box>
                <Box display={"flex"} flexDirection="row" flexWrap={"wrap"} sx={{ marginBottom: "5%" }}>
                    <Card className={classes.cards}>
                        <CardContent>
                            <Typography fontSize={26} variant="h5" component="div">
                                {apiData ? apiData.total_tickets : 0}
                            </Typography>
                            <Typography className={classes.cardssecondarytxt} fontSize={15} sx={{ mt: 1.5 }} color="text.secondary">
                                Total Tickets
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card className={classes.cards}>
                        <CardContent>
                            <Typography fontSize={26} variant="h5" component="div">
                                {apiData?.status_count?.find(element => element.status === "Pending")?.count || 0}
                            </Typography>
                            <Typography className={classes.cardssecondarytxt} fontSize={15} sx={{ mt: 1.5 }}>
                                Pending Tickets
                            </Typography>
                        </CardContent>
                    </Card>
                    <Card className={classes.cards}>
                        <CardContent>
                            <Typography fontSize={26} variant="h5" component="div">
                                {apiData?.status_count?.find(element => element.status === "Resolved")?.count || 0}
                            </Typography>
                            <Typography className={classes.cardssecondarytxt} fontSize={15} sx={{ mt: 1.5 }} color="text.secondary">
                                Resolved Tickets
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Download Button */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                    <ButtonOmni
                        onClick={downloadData}
                        size="large"
                        variant="outlined"
                        startIcon={<GetAppIcon />}
                        label={isExporting ? 'Downloading...' : 'Download'}
                        disabled={isExporting}
                    />
                </Box>
                <TableOmniNew
                    rows={apiData?.tickets || []}
                    headCells={headCells}
                    checkBox={false}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    loading={isLoading}
                    isLoadingPagination={false}
                    setCurrentParams={(updater) => {
                        const next = typeof updater === 'function' ? updater(currentParams) : updater;
                        setCurrentParams(next);
                        callApi(
                            selectedPlatform,
                            selectedAgent,
                            selectedTicketStatus,
                            selectedStartDate,
                            selectedEndDate,
                            next.page,
                            next.limit
                        );
                    }}
                    perPageRows={currentParams.limit}
                    curPage={currentParams.page}
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    totalItems={totalItems}
                    rowKey="ticket_number"
                    emptyMessage="No tickets found"
                />

                <SnackbarOmni {...snackbar} />
            </Box>
        </>
    );
}